


export function checkNull(e) {
  if (!e) {
    return { status: true, message: "" };
  } else return { status: false, message: "" };
}

export function twodecimal(e) {
  let regExp = /^\d*(\.\d{0,2})?$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Only two digits allowed after the decimal point",
    };
  else return { status: false, message: "" };
}

export function numberMax10Digits(e) {

  let regExp = /^\d{1,8}(\.\d{1,2})?$/; // Allows 10 digits with up to 2 decimal places

  if (!e.match(regExp)) {

    return {
      status: true,
      message: "Enter a number up to 10 digits with up to 2 decimal places",
    };
  } else {

    return { status: false, message: "" };
  }
}

export function isAlphanumeric(e) {
  let regExp = /^[A-Za-z0-9]*$/;
  if (!e.match(regExp))
    return { status: true, message: "Special Character not allowed" };
  else return { status: false, message: "" };
}

export function isAlphanumericWithSpace(e) {
  let regExp = /^[A-Za-z0-9\s]*$/;
  if (!e.match(regExp))
    return { status: true, message: "Special Character not allowed" };
  else return { status: false, message: "" };
}

export function isAlphanumericWithSpaceandot(e) {
  let regExp = /^[A-Za-z0-9\s.]*$/;
  if (!e.match(regExp))
    return { status: true, message: "Special Character not allowed" };
  else return { status: false, message: "" };
}

export function isAlphanumericWithSpaceandDash(e) {
  let regExp = /^[A-Za-z0-9\s-]*$/;
  if (!e.match(regExp))
    return { status: true, message: "Special Character not allowed" };
  else return { status: false, message: "" };
}

export function isAlphanumericWithSlash(e) {
  let regExp = /^[0-9\sa-zA-Z°!@#$%^&*()_./-]+$/;
  if (!e.match(regExp))
    return { status: true, message: "Special Character not allowed" };
  else return { status: false, message: "" };
}

export function isAlphanumericWithSpacehyphenUs(e) {
  let regExp = /^[A-Za-z0-9\s\-_]*$/;
  if (!e.match(regExp))
    return { status: true, message: "Special Character not allowed" };
  else return { status: false, message: "" };
}

export function isAlphanumericWithAtRate(e) {
  let regExp = /^[A-Za-z0-9@.]*$/;
  if (!e.match(regExp))
    return { status: true, message: "Special Character not allowed" };
  else return { status: false, message: "" };
}

export function isAlphanumericWithDot(e) {
  let regExp = /^[A-Za-z0-9.]*$/;
  if (!e.match(regExp))
    return { status: true, message: "Special Character not allowed" };
  else return { status: false, message: "" };
}

export function isAlphanumericWeb(e) {
  let regExp = /^([\w:@./\s]*)$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Alphanumeric with only (@ . : /) special characters allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithSpaceDash(e) {
  let regExp = /^[A-Za-z0-9\s-.()/]*$/;
  if (!e.match(regExp))
    return { status: true, message: "Special Character not allowed" };
  else return { status: false, message: "" };
}
export function isAlphanumericWithSpecialChars(e) {
  let regExp = /^[A-Za-z0-9\s\-.()/|,!#_;@$%*&:[\]]*$/;
  if (!e.match(regExp))
    return { status: true, message: "Special Characters not allowed" };
  else return { status: false, message: "" };
}

export function isNumber(e) {
  let regExp = /^[0-9\s]*$/;
  if (!e.match(regExp))
    return { status: true, message: "Enter only Numeric Digits" };
  else return { status: false, message: "" };
}

export function isNumberwithdash(e) {
  let regExp = /^[0-9\s-]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Enter only Numeric Digits with Only Dash",
    };
  else return { status: false, message: "" };
}

export function isNumberwithdashdot(e) {
  let regExp = /^[0-9\s-.]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Enter only Numeric Digits with Only Dash or Dot",
    };
  else return { status: false, message: "" };
}

export function isExperience(e) {
  let regExp = /^[0-9+.s]*$/;
  if (!e.match(regExp))
    return { status: true, message: "Enter only Numeric Digits" };
  else return { status: false, message: "" };
}

export function islessthenMaxlength(e, fieldnm) {
  if (e.target.value.length < e.target.maxLength)
    return {
      status: true,
      message: fieldnm + " length should be  " + e.target.maxLength,
    };
  else return { status: false, message: "" };
}

export function isNumbernrange(e) {
  let regExp = /^[0-9\s+]*$/;
  if (!e.match(regExp))
    return { status: true, message: "Enter only Positive digits" };
  else if (e < 1 || e > 366)
    return { status: true, message: "Enter within range i.e., 1-366" };
  else return { status: false, message: "" };
}

export function isNumberRange(e) {
  let regExp = /^[0-9\s+]*$/;
  if (e && !e.match(regExp))
    return { status: true, message: "Enter only Numberic digits." };
  else return { status: false, message: "" };
}

export function number24(e) {
  let regExp = /^((?:\d|1\d|2[0-3])(?:\.\d{1,2})?|24(?:\.00?)?)$/;
  if (!e.match(regExp))
    return { status: true, message: "Enter Value between 0 - 24" };
  else return { status: false, message: "" };
}

export function number9999(e) {
  let regExp = /^(?:\d{1,4}|9999)$/;
  if (!e.match(regExp))
    return { status: true, message: "Enter Value between 0 - 9999" };
  else return { status: false, message: "" };
}

export function isMobNumber(e) {
  let regExp = /^\+?\(?\d{3}\)?[-\s.]?\d{3}[-\s.]?\d{4,6}$/;
  if (!e.match(regExp))
    return { status: true, message: "Enter country code with mobile no." };
  else return { status: false, message: "" };
}

export function isNumberWithDecimal(e) {
  let regExp = /^[0-9.]*$/;
  if (!e.match(regExp)) return { status: true, message: "Enter only digits" };
  else return { status: false, message: "" };
}
export function isNumberWithDecimalPM(e) {
  let regExp = /^[0-9.,]*$/;
  if (!e.match(regExp)) return { status: true, message: "Enter only digits" };
  else return { status: false, message: "" };
}

export function isEmail(e) {
  let regExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
  if (!e.match(regExp))
    return { status: true, message: "Enter valid Email Id" };
  else return { status: false, message: "" };
}

export function isAlphanumericWithDotSpaceDashCommaBrackets(e) {
  let regExp = /^[-A-Za-z0-9\s.,()]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}
export function isAlphanumericWithSpaceDotAmpsDashBrackets(e) {
  let regExp = /^[-A-Za-z0-9\s.,&()]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters space &(),.- allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericampspacedotdashbrackets(e) {
  let regExp = /^[-A-Za-z0-9\s.,&()]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithDotSpaceDashCommaBracketsemail(e) {
  let regExp = /^[-A-Za-z0-9\s.,()@]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithDash(e) {
  let regExp = /^[a-zA-Z0-9-]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithDashSlash(e) {
  let regExp = /^[a-zA-Z0-9-/]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}
export function isAlphanumericWithDashDot(e) {

  let regExp = /^[a-zA-Z0-9-.]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}
export function isAlphanumericWithDashDotPercentageComma(e) {
  let regExp = /^[a-zA-Z0-9-.,%]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithSpaceDashComma(e) {
  let regExp = /^[-A-Za-z0-9\s,]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithSpaceDotDash(e) {
  let regExp = /^[A-Za-z0-9\s.-]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}
export function isAlphanumericWithSpaceDot(e) {
  let regExp = /^[-A-Za-z0-9\s.]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}
export function isAlphanumericWithSpaceDotDashSlash(e) {
  let regExp = /^[-A-Za-z0-9\s./]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithSpaceDotDashSlashComma(e) {
  let regExp = /^[-A-Za-z0-9\s.,/]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithSpaceDotDashSlashBracketColonAmpersand(e) {
  let regExp = /^[A-Za-z0-9\s./()[\]{}:;&-]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithSpaceDotDashSlashColon(e) {
  let regExp = /^[A-Za-z0-9\s./()[\]:-]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithDashSlashDot(e) {
  let regExp = /^[-A-Za-z0-9./]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithSpaceDashCommaSlash(e) {
  const allowedPattern = /^[-A-Za-z0-9\s.,/]*$/;
  const isValid = e.match(allowedPattern);
  return isValid
    ? { status: false, message: "" }
    : { status: true, message: "Special Characters not allowed" };
}

export function isAlphanumericWithDotSpaceDashCommaBracketsColonSlash(e) {
  let regExp = /^[-A-Za-z0-9\s.,()/:]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}


export function isAlphanumericWithDotSpaceDashCommaBracketsColonSlashampersand(e) {
  let regExp = /^[-A-Za-z0-9\s.,()/:&]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}


export function isAlphanumericWithDotSpaceDashCommaBracketsSlashAmpersand(e) {
  let regExp = /^[-A-Za-z0-9\s.,()/&]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message:
        "Special Characters other than space,.,(),comma,&,-,/ are not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithDotSpaceDashCommaBracketsSlash(e) {
  let regExp = /^[-A-Za-z0-9\s.,()/]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}



export function isAlphanumericWithDashDotSlashSpaceBrackets(e) {
  let regExp = /^[-A-Za-z0-9\s.()/]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithDotSpaceDashCommaBracketsAmpersand(e) {
  let regExp = /^[-A-Za-z0-9\s,.()&]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message:
        "Special Characters other than space,.,(),comma,&,-,/ are not allowed",
    };
  else return { status: false, message: "" };
}

export function isNumberWith2digits(e) {
  let regExp = /^\d{1,2}$/;
  if (!e.match(regExp))
    return { status: true, message: "Enter Value between 0 - 99" };
  else return { status: false, message: "" };
}

export function numberMax6Digits(e) {
  let regExp = /^\d{1,6}(\.\d{1,2})?$/;



  if (e.toString().length > "6") {

    return {
      status: true,
      message:
        "Enter a number up to 6 digits with up to 2 decimal places including decimal",
    };
  } else {

    // Allows 6 digits with up to 2 decimal places
    if (!e.toString().match(regExp))
      return {
        status: true,
        message: "Enter a number up to 6 digits with up to 2 decimal places",
      };
    else return { status: false, message: "" };
  }
}



export function isRealNumber(e) {


  let regExp = /^[0-9\s]*$/;
  if (!e.match(regExp) || e <= 0)
    return {
      status: true,
      message: "Enter only numeric digits greater than 0 ",
    };
  else return { status: false, message: "" };
}




export function getDecimal(num) {
  return parseFloat(num.toString().split(".")[1]);
}

export function handleOnInput(e, i, name, TypeofCheck, detailObj) {

  let hasErr;
  let err,
    count = 0;


  detailObj.forEach((obj, index) => {

    let value = obj[name];
    if (i === index) value = e.target.value;

    if (!value) return;

    err = TypeofCheck(value);

    if (err.status === true) {
      count = 1;
    }
  });



  if (count > 0)
    hasErr = {
      status: true,
      message: "Special Characters not allowed",
    };
  else
    hasErr = {
      status: false,
      message: "",
    };

  return hasErr;
}


export function isAlphanumericAllCharacters(e) {
  let regExp = /^[A-Za-z0-9\s,+:;.@#$&*°%()_!/-]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message:
        process.env.REACT_APP_SPECIAL_CHARACTER_MSG,
    };
  else return { status: false, message: "" };
}

export function isAlphanumericAllCharactersextra(e) {
  let regExp = /^[A-Za-z0-9\s,+:;.@#$&*()_!°C%<>-]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message:
        process.env.REACT_APP_SPECIAL_CHARACTER_MSG,
    };
  else return { status: false, message: "" };
}


export function isAlphanumericAllCharactersextraBackslash(e) {
  let regExp = /^[A-Za-z0-9\s,+:;.@#$&*()_!%<>/-]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message:
        "Special Characters not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericAllSpecialCharacters(e) {
  let regExp = /^[A-Za-z0-9\s,{}?\/|\\:°.@$*()\_!+\u00B1\]^-]*$/;

  if (!e.match(regExp))
    return {
      status: true,
      message: process.env.REACT_APP_SPECIAL_CHARACTER_MSG1
    };
  else return { status: false, message: "" };
}

export function isAlphanumericAllSpecialCharactersDashPlusMinus(e) {
  let regExp = /^[A-Za-z0-9\s,{}?\/|\\:.@$*()\+\-\u00B1\]^_!]*$/;

  if (!e.match(regExp))
    return {
      status: true,
      message: process.env.REACT_APP_SPECIAL_CHARACTER_MSG1
    };
  else return { status: false, message: "" };
}

export function isAlphanumericAllSpecialCharactersDashPlusMinusDegree(e) {
  let regExp = /^[A-Za-z0-9\s,{}?\/|\\:°.@$*()\+\-\u00B1\]^_!]*$/;

  if (!e.match(regExp))
    return {
      status: true,
      message: process.env.REACT_APP_SPECIAL_CHARACTER_MSG1
    };
  else return { status: false, message: "" };
}


export function isAlphanumericAllSpecialCharactersPlusMinusDegree(e) {
  let regExp = /^[A-Za-z0-9\s,{}?\/|\\:°.@$*()\-+\u00B1&\]^_!]*$/;

  if (!e.match(regExp))
    return {
      status: true,
      message: process.env.REACT_APP_SPECIAL_CHARACTER_MSG1
    };
  else return { status: false, message: "" };
}

export function isAlphanumericAllSpecialCharactersPlusMinusDegreeWithAngleBrackets(e) {
  let regExp = /^[A-Za-z0-9\s,{}?\/|\\:°.@$*()\-+\u00B1&\]^_!<>]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: process.env.REACT_APP_SPECIAL_CHARACTER_MSG1
    };
  else return { status: false, message: "" };
}










export function isAlphanumericSpecialCharactersRestricted(e) {
  let regExp = /^(?![+\-=" #;'%]{1,5})[A-Za-z0-9\s.()|,!_@$*:[\]\-\/\+&]*$/

  if (!e.match(regExp))
    return {
      status: true,
      message: process.env.REACT_APP_SPECIAL_CHARACTER_MSG
    };
  else return { status: false, message: "" };
}

export function isAlphanumericSpecialCharactersRestrictedChar(e) {
  let regExp = /^(?![=" #;'%]{1,5})[A-Za-z0-9\s.()|,!_@$*:[\]\-\/\+&\u00B1]*$/
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters # $ ' < > = ; not allowed"
    };
  else return { status: false, message: "" };
}



export function isAlphanumericAllSpecialCharactersAmpersand(e) {
  let regExp = /^[A-Za-z0-9\s,^{}?/|\]:°.@$*()_!\-&\/\+\u00B1]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: process.env.REACT_APP_SPECIAL_CHARACTER_MSG2
    };
  else
    return { status: false, message: "" };
}





export function isAlphanumericWithPlusAmpersandEqualsPlusMinus(e) {
  let regExp = /^[A-Za-z0-9\s,^{}?/|\]:°.@$*()_!+&=±-]*$/;

  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters # % $ ' < > ; not allowed"
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithPlusandEqualsPlusMinus(e) {
  let regExp = /^[A-Za-z0-9\s,^{}?/|\]:°.@$*()_!+=±-]*$/;

  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters # & % $ ' < > ; not allowed"
    };
  else return { status: false, message: "" };
}


export function isAlphanumericWithPlusAmpersandEqualsLessThanMinus(e) {
  let regExp = /^[A-Za-z0-9\s,^{}?/|\]:°.@$*()_!+&=±<-]*$/;

  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters # % $ ' > ; not allowed"
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithPlusAmpersandEqualsPercentMinus(e) {
  let regExp = /^[A-Za-z0-9\s,^{}?/|\]:°.@$*()_!+&=%±-]*$/;

  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters # $ ' < > ; not allowed"
    };
  else return { status: false, message: "" };
}


export function isAllowCustomSpecialCharacters(e, additionalSpecialChars = "", customMessage = "") {

  // Combine the default special characters with the additional ones
  let regExp = new RegExp(`^[A-Za-z0-9\\s,^{}?/|\\]\\[\\\\:°.@$*()_!/${additionalSpecialChars}]*$`);
  if (!e.match(regExp)) {
    return {
      status: true,
      message: customMessage
    };
  } else {
    return { status: false, message: "" };
  }
}





export function isAlphanumericWithDashSlashPlus(e) {
  let regExp = /^[A-Za-z0-9\s\-/+]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters other than - / + are not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithDashSlashPlusAmpersand(e) {
  let regExp = /^[A-Za-z0-9\s\-/+&°]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters other than - / + & ° are not allowed",
    };
  else return { status: false, message: "" };
}

export function isAlphanumericWithDiameterDashSlash(e) {
  let regExp = /^[A-Za-z0-9\s\-/\u00D8\u2300]*$/;
  if (!e.match(regExp))
    return {
      status: true,
      message: "Only alphanumeric, Ø, - , / are allowed",
    };
  else return { status: false, message: "" };
}

export function SquareBracketNotAllowed(e, additionalSpecialChars = "", customMessage = "") {




  let escapedChars = additionalSpecialChars.replace(/-/g, '\\-');
  let regExp = new RegExp(
    `^[A-Za-z0-9\\s,^{}?/|\\]\\\\:°.@$*()_!/${escapedChars}]*$`
  );
  if (!e.match(regExp)) {
    return {
      status: true,
      message: customMessage
    };
  } else {
    return { status: false, message: "" };
  }
}
export function isSpecialCharactersNotes(e) {
  let regExp = /^[A-Za-z0-9\s,^{}?/|\]:°.@$*()_!=&+%±-]*$/;

  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters # $ ' < >  ; not allowed"
    };
  else return { status: false, message: "" };
}

export function isAllowDashedPlusSpecialCharacters(e) {
  let regExp = /^[A-Za-z0-9\s,^{}?/|\]:°.@$*()_!+±-]*$/;

  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters # & % $ ' < > = ; not allowed"
    };
  else return { status: false, message: "" };
}



export function isAllowDashedSpecialCharacters(e) {
  let regExp = /^[A-Za-z0-9\s,^{}?/|\]:°.@$*()_!-]*$/;

  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters # & % + $ ' < > = ; not allowed"
    };
  else return { status: false, message: "" };
}





export function isAllowDashedSpecialCharactersPlusMinusPercentAmpersand(e) {
  let regExp = /^[A-Za-z0-9\s,{}?\/|\\:°.@$*()\-+&%\u00B1\]^_!]*$/


  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters #  $ ' < > = ; not allowed"
    };
  else return { status: false, message: "" };
}







export function isAllowedDashedAmpersSpecialCharacters(e) {
  let regExp = /^[A-Za-z0-9\s,^{}?/|\]:°.@$*()_!&-]*$/;

  if (!e.match(regExp))
    return {
      status: true,
      message: "Special Characters # % + $ ' < > = ; not allowed"
    };
  else return { status: false, message: "" };
}



export function isAllowDashedAndSpecialCharacters(e) {
  const pattern = /^[A-Za-z0-9\s,^{}?/|\]:°.@$*()_!&-]*$/;
  return !e.match(pattern)
    ? { status: true, message: "Special Characters # % + $ ' < > = ; not allowed" }
    : { status: false, message: "" };
}

export function isAllowDashedPercentageSpecialCharacters(e) {
  // Updated regular expression to include %
  let regExp = /^[A-Za-z0-9\s,^{}?/|\]:°.@$*()_!%-]*$/;

  if (!e.match(regExp)) {
    return {
      status: true,
      message: "Special Characters # & + $ ' < > = ; not allowed"
    };
  } else {
    return { status: false, message: "" };
  }
}

export function isAlphanumericMinusPlusPercent(e) {
  let regExp = /^[A-Za-z0-9\s,{}?\/|\\:°.@$*()\-+%±&\]^_!]*$/;
  if (!e.match(regExp))
    return { status: true, message: "Special Characters  # $ ' < > not allowed" };
  else return { status: false, message: "" };
}

export function isAlphanumericMinusPlusPercentDiameter(e) {
  let regExp = /^[A-Za-z0-9\s,{}?\/|\\:°.@$()\-+&%\u00B1\u00D8\u2300\]^_!]*$/
  if (!e.match(regExp))
    return { status: true, message: "Special Characters # $ ' < > not allowed" };
  else return { status: false, message: "" };
}



export default function Validate(file) {
  let error = "";
  let fileName = file.name;
  let fileExtn =
    fileName.indexOf(".") > 0
      ? fileName.split(".").pop().toLowerCase()
      : "undefined";
  let fileSize = file.size;

  let allowedExtensions = process.env.REACT_APP_DEVIATION_FILE_EXTENSIONS;


  if (fileName.match(/\./g).length !== 1) {
    error = error + "File name contains more than one dot. ";
  }

  if (!allowedExtensions.includes(fileExtn)) {
    error = error + "Unsupported file format. ";
  }

  if (fileSize > 5242880) {
    error = error + "File size is greater than 5MB.";
  }
  return error;
}
